import round4 from './round4';

/**
 * Create a stable string key for a Leaflet bounds object.
 * @param {import('leaflet').LatLngBounds} bounds
 * @param {string} [extra]
 * @returns {string}
 */
const boundsKey = (bounds, extra = '') => {
	const sw = bounds.getSouthWest();
	const ne = bounds.getNorthEast();
	return `${round4(sw.lat)}:${round4(sw.lng)}|${round4(ne.lat)}:${round4(
		ne.lng
	)}|${extra}`;
};

export default boundsKey;
